import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import mainIcon from "../../../assets/mainIcon.png";
import { useDispatch } from "react-redux";
import { logout } from "../../../services/auth/auth.slice";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdOutlineLogout } from "react-icons/md";
// import { FaChevronDown } from "react-icons/fa";

import routes from "../../../routes/routes";

const Sidebar = () => {
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [expandedMenus, setExpandedMenus] = useState({});

  const sidebarRoutes = routes.filter(
    (route) =>
      route.layout === "app" &&
      route.icon &&
      (!route.roles || (user && route.roles.includes(user.role)))
  );

  // Automatically expand parent if a child is active
  useEffect(() => {
    const newExpanded = { ...expandedMenus };
    sidebarRoutes.forEach((route) => {
      if (route.children && route.children.length > 0) {
        const isChildActive = route.children.some((child) => {
          const childPath = `${route.path}/${child.path}`.replace(/\/+/g, "/");
          return location.pathname === childPath;
        });
        // Also expand if the parent route itself is active
        if (isChildActive || location.pathname.startsWith(route.path)) {
          newExpanded[route.path] = true;
        }
      }
    });
    setExpandedMenus(newExpanded);
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleToggle = (path) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [path]: !prev[path],
    }));
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };
  return (
    <aside className="w-[110px] bg-primary shadow-md flex-shrink-0 hidden md:block">
      <div>
        <div className="h-[57px] flex items-center justify-center">
          <img className="w-12" src={mainIcon} alt="logo" />
        </div>
        <div className="flex items-center justify-center mb-1">
          <p className="text-sm font-bold text-white">{user?.username}</p>
        </div>
        <hr className="border-white/20" />

        <nav className="mt-2">
          {sidebarRoutes.map((route) => {
            const Icon = route.icon;
            const isActive = location.pathname.startsWith(route.path);
            const hasChildren = route.children && route.children.length > 0;

            const isExpanded = !!expandedMenus[route.path];

            return (
              <div key={route.path}>
                <div className="relative">
                  {hasChildren ? (
                    <div
                      onClick={() => handleToggle(route.path)}
                      className={`flex flex-col items-center justify-center py-2 text-xs font-medium text-white gap-2 transition-all duration-200 mx-2 rounded-md relative cursor-pointer ${
                        isActive &&
                        !location.pathname.includes(`${route.path}/`)
                          ? "bg-white/20 shadow-sm"
                          : "hover:bg-white/10"
                      }`}
                    >
                      {Icon && (
                        <Icon
                          className={`transition-transform duration-200 ${
                            route.name === "Configuration"
                              ? "text-sm"
                              : "text-lg"
                          } ${isActive ? "scale-110" : ""}`}
                        />
                      )}
                      <div className="flex flex-col items-center justify-center gap-1 w-full px-1 overflow-hidden">
                        <span className="leading-none whitespace-nowrap overflow-hidden text-ellipsis w-full text-center">
                          {route.name}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <Link
                      to={route.path}
                      className={`flex flex-col items-center justify-center py-2 text-xs font-medium text-white gap-2 transition-all duration-200 mx-2 rounded-md relative ${
                        isActive ? "bg-white/20 shadow-sm" : "hover:bg-white/10"
                      }`}
                    >
                      {Icon && (
                        <Icon
                          className={`text-lg transition-transform duration-200 ${
                            isActive ? "scale-110" : ""
                          }`}
                        />
                      )}
                      <span className="leading-none">{route.name}</span>
                    </Link>
                  )}
                </div>

                {/* Render Nested Children */}
                {hasChildren && isExpanded && (
                  <div className="flex flex-col gap-1 mt-2 mb-3">
                    {route.children
                      .filter((child) => child.name) // only show children with names
                      .filter(
                        (child) =>
                          !child.roles ||
                          (user && child.roles.includes(user.role))
                      )
                      .map((child) => {
                        const childPath = `${route.path}/${child.path}`.replace(
                          /\/+/g,
                          "/"
                        );
                        const isChildActive =
                          location.pathname === childPath ||
                          (child.path === "" &&
                            location.pathname === route.path);

                        return (
                          <Link
                            key={childPath}
                            to={childPath}
                            className={`flex items-center text-[11px] font-medium py-2 px-3 transition-all duration-200 mx-2 rounded-md whitespace-nowrap overflow-hidden text-ellipsis ${
                              isChildActive
                                ? "text-white bg-white/20 font-bold"
                                : "text-white/50 hover:text-white/80 hover:bg-white/5"
                            }`}
                          >
                            {child.name}
                          </Link>
                        );
                      })}
                  </div>
                )}
                <hr className="border-white/20 my-2" />
              </div>
            );
          })}
        </nav>
      </div>
      {/* Logout Button in bottom */}
      <div className="fixed bottom-0 w-[110px] p-2">
        <button
          onClick={handleLogout}
          className="w-full flex flex-col items-center justify-center py-2 text-xs font-semibold text-white gap-2 transition-colors rounded-md bg-white/10 hover:bg-white/10"
        >
          <MdOutlineLogout className="text-lg" />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
